module.exports = __webpack_public_path__ + "static/actionbar-case-dont-8e09c12095d044feb3086e2f9b59cebd.png";